<template>

  <v-card>
  <v-toolbar class="elevation-1">
  <v-toolbar-title>  
    Middle Managers
    </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-btn @click="addMiddleManager()">Add Middle Manager</v-btn>
    </v-toolbar>
    <v-data-table
              :headers="headers"
              :items="items"
              item-key="id"
              :pagination.sync="pagination"
              :total-items="totalItems"
              :loading="loading"
              :rows-per-page-items="rowsPerPageItems"
            class="elevation-1"
          >
          <template slot="items" slot-scope="props">
            <!-- <td>{{ props.item.title }}</td> -->
            <td>{{ props.item.firstName }}</td>
            <td>{{ props.item.lastName }}</td>
            <td>{{ props.item.email }}</td>
            <td>
              <v-tooltip bottom>
                  <v-btn slot="activator" fab small color="red" outline
                  @click.stop="loadDialog(props.item)"
                  v-bind:value="props.item.id"
                  >
                      <v-icon dark>delete</v-icon>
                  </v-btn>
                  <span>Revoke Access</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn slot="activator" fab dark small color="grey" outline 
                  :to="{ name: 'MiddleManagerClasses', params: { managerId: props.item.id }}">
                  <v-icon dark>settings</v-icon>
                </v-btn>
                <span>Manage Classes</span>
              </v-tooltip>
            </td>
          </template>
    </v-data-table>
    <v-dialog v-model="dialogAddMiddleManager" max-width="40%">
      <v-card>
          <v-card-title>
              Add Middle Manager
          </v-card-title>
          <v-card-text>
          <template>
              <v-layout row>
                  <v-autocomplete
                    v-model="selectedTeacher"
                    :items="teacherNames"
                    label="Select Teacher"
                    outlined
                  ></v-autocomplete>
              </v-layout>
          </template>

          </v-card-text>
          <v-card-actions>
              <v-btn color="primary" flat @click.stop="dialogAddMiddleManager = false;">Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click.stop="saveMiddleManager()">Save</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" max-width="40%">
          <v-card>
              <v-card-title>
                  Confirmation
              </v-card-title>
              <v-card-text>
                  <v-layout row wrap>
                      <v-layout row wrap>
                              This action will remove the Middle Manager Access Level for teacher &nbsp; 
                              <b> {{ teacherName }} </b>
                          </v-layout>
                  </v-layout>
              </v-card-text>
              <v-card-actions>
                  <v-btn color="primary" flat @click.stop="unloadDialog()">Cancel</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" flat @click.stop="deleteMM()">Delete</v-btn>
              </v-card-actions>
          </v-card>
      </v-dialog>
  </v-card>
</template>


<script>
  import { initialize, getList, getListByPeriod, getNonMiddleManagers, postMiddleManager, deleteMiddleManager } from '../utils/effort-tracking-api';
  import { globalStore } from '../main'

  export default {
    data: () => ({
        search: '',
        loading: false,
        totalItems: 0,
        rowsPerPageItems: globalStore.rowsPerPageItems,
        pagination: { sortBy: 'lastName', rowsPerPage: globalStore.defaultRowsPerPage },
        headers: [
          // { text: 'Title', value: 'title'},
          { text: 'First Name', value: 'firstName' },       
          { text: 'Last Name', value: 'lastName' },
          { text: 'Email', value: 'email' },
          { text: 'Actions', value: '', sortable: false }
        ],
        items: [],
        dialogAddMiddleManager: false,
        allTeachers: [],
        teacherNames: [],
        selectedTeacher: "",
        delMiddleManagerId: 0,
        teacherName: '',
        dialog: false
    }),
    methods: {
      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      getDataFromApi () {
        this.loading = true;
        initialize().then(x => {
          getListByPeriod("middlemanagers", this.pagination, this.search).then(data => {
            console.log('Middle Managers');
            console.log(data);
            this.items = data.items;
            this.totalItems = data.count;
            this.loading = false;
          })
        });
      },
      loadDialog(item) {
          console.log(item);
          // this.alertSuccess = false;
          // this.alertError = false;
          this.teacherName = item.firstName + ' ' + item.lastName;

          // this.delClassId = item.classId;
          this.delMiddleManagerId = item.id;
          // this.delReportingPeriodClassId = item.reportingPeriodClassId;
          this.dialog = true;
      },
      unloadDialog() {
          this.dialog = false;
          this.delMiddleManagerId = 0;
          this.selectedTeacher = '';
      },
      addMiddleManager() {
          this.loading = true;
          console.log('GETTING TEACHERS');
          initialize().then(x => {
            getNonMiddleManagers("").then(data => {
              this.allTeachers = data;
              data.forEach(element => {
                  this.teacherNames.push(element.name);
              });
              // //this.totalItems = data.count;
              this.loading = false;
              this.dialogAddMiddleManager = true;
            });
          });
      },
      saveMiddleManager()
      {
          console.log('Save Middle Manager');
          console.log(this.selectedTeacher);
          // console.log(this.allTeachers);

          var teacherId = this.allTeachers.filter(tt => tt.name == this.selectedTeacher)[0].id;
          console.log(teacherId);
          // var classId = this.$route.params.classId;

          postMiddleManager(teacherId).then(response => {
              console.log(response);
              this.debouncedGetDataFromApi();
          });

          this.dialogAddMiddleManager = false;
      },
      deleteMM() {
          this.dialog = false;
          console.log('DELETE MID MANAGER');
          console.log(this.delMiddleManagerId);
          deleteMiddleManager(this.delMiddleManagerId).then(result => {
              console.log(result);
              this.debouncedGetDataFromApi();
          }).catch(ex => { console.log(ex) });
        },
    },
    watch: {
      search: {
        handler () {
           this.debouncedGetDataFromApi()
        },
      },
      pagination: {
        handler () {
          this.debouncedGetDataFromApi();
        },
        deep: true
      }
    },
    mounted () {
      this.debouncedGetDataFromApi = _.debounce(this.getDataFromApi, 500, { trailing:true })
    },
  }
  
</script>



// WEBPACK FOOTER //
// src/components/MiddleManagers.vue